<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #eventPopoverAnchor="satPopoverAnchor" type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="eventFiltersPopover" (click)="eventFiltersPopover.toggle()"
                [class.results-listing__filter--active]="eventPopoverAnchor.isPopoverOpen()">
          Event Filters
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
        <mat-slide-toggle class="results-listing__airports-toggle" [(ngModel)]="showAirports"
                          (change)="onShowAirportsToggleChanged()">Show Airport Pins</mat-slide-toggle>
      </div>
      <div #aviationEventListEl *ngIf="aviationEvents && aviationEvents.length > 0; else placeholder" class="results-listing__list">
        <app-event-summary-card
          #aviationEventEl *ngFor="let aviationEvent of aviationEvents"
          [aviationEvent]="aviationEvent" [active]="aviationEvent === activeAviationEvent"
          [interactive]="true"
          [compact]="true"
          (eventMouseEnter)="onEventHover(aviationEvent, true)"
          (eventMouseLeave)="onEventHover(aviationEvent, false)">
        </app-event-summary-card>
      </div>
      <mat-paginator
        *ngIf="aviationEvents && aviationEvents.length > 0"
        class="results-listing__pagination"
        [pageIndex]="eventPageIndex"
        [length]="totalAviationEvents"
        [pageSize]="eventPageSize"
        (page)="onEventPageChanged($event)">
      </mat-paginator>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">
      No results found matching your search criteria. Try reducing the number of filters used in the search.
    </div>
  </div>
</ng-template>


<sat-popover #eventFiltersPopover horizontalAlign="start" verticalAlign="below" hasBackdrop>
  <div class="results-listing__popover">
    <app-event-filter-list #eventFilters [query]="query" [compact]="true"
                             (filtersChange)="onFiltersChanged()"
                           (filtersChangeDate)="onFiltersChangedDate()">
    </app-event-filter-list>
  </div>
</sat-popover>
